import React, { useState, useEffect } from 'react';
import AdminLogin     from './AdminLogin';
import AdminDashboard from './AdminDashboard';
import { getMe }      from './api';
import './admin.css';

const AdminApp = () => {
  const [user, setUser]       = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('saanvi_admin_token');
    if (!token) { setChecking(false); return; }
    getMe()
      .then(r => { if (r.success) setUser(r.admin.username); })
      .catch(() => {})
      .finally(() => setChecking(false));
  }, []);

  const handleLogin  = (username) => setUser(username);
  const handleLogout = () => {
    localStorage.removeItem('saanvi_admin_token');
    localStorage.removeItem('saanvi_admin_user');
    setUser(null);
  };

  if (checking) {
    return (
      <div className="admin-app" style={{ display:'flex', alignItems:'center', justifyContent:'center', minHeight:'100vh', background:'linear-gradient(135deg,#050516,#1a1a5e)' }}>
        <div style={{ color:'white', fontSize:'1.1rem', display:'flex', alignItems:'center', gap:12 }}>
          <span style={{ fontSize:'1.6rem', animation:'spin 1s linear infinite', display:'inline-block' }}>⚙️</span>
          Loading Admin Panel...
        </div>
      </div>
    );
  }

  return (
    <div className="admin-app">
      {user
        ? <AdminDashboard username={user} onLogout={handleLogout} />
        : <AdminLogin onLogin={handleLogin} />
      }
    </div>
  );
};

export default AdminApp;
